export default {
  name: 'dateFormat',
  filter (value) {
    return value && value.length > 0 ? value.slice(0, 10) : value
  }
}